/* eslint-disable no-empty */
/* eslint-disable no-console */
import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { FormControlTypeEnum } from './form-control-type.enum';
import { AppVariables } from '@shared';

export type ITFormControlType = string | number | boolean | null;

export class FormControlBase<T> {
	public value: T;
	public key: string;
	public label: string;
	public required: boolean;
	public disabled: boolean;
	public validators: Record<string, ValidatorFn[]>;
	public asyncValidators: Record<string, AsyncValidatorFn[]>;
	public validationMessages: { [key: string]: string }[];
	public order: number;
	public controlType: FormControlTypeEnum;
	public type: string;
	public width: number;
	public edit_style: string;
	public options: { key: string; value: string }[];

	public constructor(optionsInput: Partial<FormControlBase<T>>) {
		console.log("Option Input: ", optionsInput);
		
		this.value = optionsInput.value;
		this.key = optionsInput.key || '';
		this.label = optionsInput.label || '';
		this.required = !!optionsInput.required;
		this.disabled = optionsInput.disabled;
		this.validators = optionsInput.validators;
		this.asyncValidators = optionsInput.asyncValidators;
		this.validationMessages = optionsInput.validationMessages;
		this.order = optionsInput.order ?? AppVariables.END_ORDER;
		this.controlType = optionsInput.controlType;
		this.type = optionsInput.type || '';
		this.width = optionsInput.width;
		this.edit_style = optionsInput.edit_style;
		this.options = optionsInput.options || [];
		if (optionsInput.key === 'activity_shift') {
			this.validators.activity_shift.splice(1,1);
		}
		if(optionsInput.key === 'drill_hole_status') {
			this.validators.drill_hole_status.splice(0,1);
		}
	}
}
